/*
 * @Author: Tina Huang
 * @Date: 2024-11-01 14:11:27
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2025-07-31 19:37:01
 * @Description:
 */
import { Button, Image, Rate, Tag } from 'antd'
import styles from './comments.module.css'

type FansComment = {
  // avatar: string
  nickname: string
  star?: number
  desc: string
  from?: string
  reply?: string
  defaultAvatar?: boolean
}

export default function PanelFans() {
  const isMobile = window.innerWidth <= 750
  const comments: FansComment[] = [
    {
      nickname: '黄豆酱子',
      desc: '我是一个在校大学生，作为一个J人从高中开始就喜欢做手帐记录来安排自己的生活，上大学之后通过阿汪了解接触到了Notion这个软件，帮我开启了新世界，现在已经完全离不开了，而且阿汪的设计真的又好看又实用，我已经分享给好多朋友了。',
      from: '小红书',
    },
    {
      nickname: '居居妮',
      desc: '社畜打工人牛马一枚，之前为了找工作管理的计划表机缘巧合搜到了卷卷（阿汪同学），一下子被所呈现的封面给吸引了，从一开始的难以上手，到现在驾轻就熟，卷卷给了我很多帮助，也学习到了很多，现在慢慢开始自己设计自己的内容，太感谢卷卷了！！！会一直支持！！！',
      from: '小红书',
    },
    {
      nickname: '林夕',
      desc: '关注阿汪好几年了，很多免费模板都超级好用！！！是我关注的最宝藏的notion博主~陆续也买了一些，最近有想入永久会员的冲动！打算发了工资就加入！',
      from: '小红书',
    },
    {
      nickname: 'otakufish',
      desc: '一直以來對您所製作的模板都十分喜歡，但由於人在海外，用淘寶真的很不方便……所以每次想支持購買都沒辦法，希望能多增加些別的購買渠道',
      from: 'BiliBili',
      reply: '😄 努力扩展中',
    },
    {
      nickname: 'Olivia',
      desc: '剛入坑阿汪同學的時候就直接一口氣買了好幾個模板，然後帶著我摸索熟悉Notion，現在我已經可以完全熟練的建立自己的知識體系啦！後面就直接入了阿汪的永久會員，物超所值，太幸運能遇到你了！',
      from: 'Bilibili',
    },
    {
      nickname: '红油',
      desc: '阿汪你的公式真的太棒了！设计得很巧妙！你的排版也很漂亮！所有模版的设计思路都很清晰也很有逻辑！总之我想说的是阿汪的设计既好看又实用！',
      from: 'Bilibili & 小红书',
      defaultAvatar: true,
    },
    {
      nickname: '兮兮',
      desc: '从b站关注到阿汪，一直追随到公众号、小红书，阿汪每份模版的用心和巧妙设计是其他人无法比拟的，是模版界的良心up，ღ( ´･ᴗ･` )比心！希望阿汪越来越好！',
      from: 'Bilibili',
      defaultAvatar: true,
    },
    {
      nickname: '柚子呼噜下大雨',
      desc: '谢谢你，我看到了好多notion的新用法。对我的工作和生活有很大的帮助。',
      from: '小红书',
      defaultAvatar: true
    }
  ]

  const PlatformTag = (props: any) => {
    if (!props.platform) return <></>
    let color = 'red'
    return <Tag color={color}>{props.platform}</Tag>
  }

  return (
    <div id="comments">
      {/* <img src="" alt="" /> */}
      <h1 className="text-2xl font-bold underline underline-offset-8 decoration-rose-800 text-center">Widverse / 阿汪同学的支持者们</h1>
      <div className="text-center">
        <Button
          type="primary"
          href="https://httishere666.notion.site/1316018c38ee803fb09ade8371f953ff?pvs=105"
          className="mt-6"
          target="_blank"
        >
          <strong>写下你想对我说的话吧～</strong>
        </Button>
      </div>
      <div className={styles.list} style={{ padding: isMobile ? '0 20px' : '0 40px' }}>
        {comments.map((user, index) => {
          // const rand = Math.random() * 40 + Math.random() * 50 + Math.random() * (index % 3) * 40
          return (
            <div
              className={`${styles.testimonial} ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}
              // style={{ paddingLeft: index 100% 2 === 0 ? rand : 0, paddingRight: index % 2 === 0 ? 0 : rand }}
            >
              <div className={styles.info}>
                <Image src={`./assets/fans/${user.defaultAvatar ? 'default' : user?.nickname}.png`} className={styles.infoAvatar} />
                <h3 className="text-center">
                  <span className="font-bold">{user?.nickname}</span>
                </h3>
              </div>
              <div className={styles.quoteBox}>
                <Rate disabled allowHalf defaultValue={user?.star || 5} className="mr-2" /> <PlatformTag platform={user?.from} />{' '}
                {user?.desc}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
